
import apiConfig from "../ApiConfig";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// -------------------------------
// CREATE or UPDATE USER
// -------------------------------
export const saveUserApi = async (payload, editingUserId) => {
  try {
    let response;
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (Array.isArray(payload[key])) {
        payload[key].forEach((value) => {
          formData.append(key, value);
        });
      } else {
        formData.append(key, payload[key]);
      }
    });
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    if (editingUserId) {
      response = await apiConfig.put(
        `${BACKEND_URL}/api/admin-user/user/${editingUserId}/`,
        formData,
        config
      );
    } else {
      response = await apiConfig.post(
        `${BACKEND_URL}/api/admin-user/create-user/`,
        formData,
        config
      );
    }
    return response;
  } catch (err) {
    console.error("❌ saveUserApi error:", err.response?.data || err.message);
    throw err;
  }
};

// -------------------------------
// FETCH ALL USERS
// -------------------------------
export const fetchUsersApi = async (page, page_size, filters = {}) => {
  try {
    const params = { page, page_size };
    if (filters.email) params.email = filters.email;
    if (filters.username) params.username = filters.username;
    if (filters.role) params.role = filters.role;
    if (filters.company) params.company = filters.company;
    const res = await apiConfig.get(
      `/api/admin-user/users/`,
      { params }
    );
    return res.data;
  } catch (error) {
    console.error("❌ fetchUsersApi error:", error);
    throw error;
  }
};

// ---------------------
// FETCH CONFIG SETTINGS
// ---------------------
export const fetchConfigSettingsApi = async () => {
  try {
    console.log({ BACKEND_URL });
    const res = await apiConfig.get(`${BACKEND_URL}/api/config-settings/`);
    return res.data; // returning all config values
  } catch (error) {
    console.error("❌ fetchConfigSettingsApi error:", error);
    throw error;
  }
};

// ---------------------
// FETCH COMPANIES LIST
// ---------------------
export const fetchCompaniesApi = async (searchTerm = "", selectedCompaniesId = []) => {
  try {
    const payload = {
      "search": searchTerm,
      "selectedCompaniesId": selectedCompaniesId
    }
    const res = await apiConfig.post(
      `/api/customer-master/companies/`, payload
    );
    return res.data;
  } catch (error) {
    console.error("❌ fetchCompaniesApi error:", error);
    throw error;
  }
};
export const fetchSecurityAnalystsCompanyApi = async (userId, type) => {
  try {
    const res = await apiConfig.get(
      `${BACKEND_URL}/api/security-analyst/companies-by-user/${userId}`,
      { params: { type } }
    );
    return res.data;
  } catch (error) {
    console.error("❌ fetchSecurityAnalystsCompanyApi error:", error);
    throw error;
  }
}
// Platform admin: start a password reset for a user. Cognito emails the user;
// the admin never sees or sets the password.
export const resetUserPasswordApi = async (userId) => {
  try {
    const res = await apiConfig.post(
      `${BACKEND_URL}/api/admin-user/user/${userId}/reset-password/`
    );
    return res.data;
  } catch (error) {
    console.error("❌ resetUserPasswordApi error:", error);
    throw error;
  }
};

export const deleteUserApi = async (userId) => {
  try {
    const res = await apiConfig.delete(
      `${BACKEND_URL}/auth/${userId}/delete_user`
    );
    return res.data;
  } catch (error) {
    console.error("❌ deleteUserApi error:", error);
    throw error;
  }
};

export const fetchSecurityAnalystsCompaniesApi = async (page = 1, limit = 3, userId, type = "preview") => {
  try {
    const res = await apiConfig.get(
      `${BACKEND_URL}/api/security-analyst/companies-by-user/${userId}`, {
      params: {
        page: page,
        limit: limit,
        type: type,
      }
    }
    );
    return res.data;
  } catch (error) {
    console.error("❌ fetchSecurityAnalystsCompaniesApi error:", error);
    throw error;
  }
};
export const fetchAuditorsCompaniesApi = async (userId, page = 1, limit = 3, type = "preview") => {
  try {
    const res = await apiConfig.get(
      `${BACKEND_URL}/api/auditors/companies/${userId}`, {
      params: {
        page: page,
        limit: limit,
        type: type
      }
    }
    );
    return res.data;
  } catch (error) {
    console.error("❌ fetchAuditorsCompaniesApi error:", error);
    throw error;
  }
};